import { createFileRoute, redirect } from '@tanstack/react-router';
import { logout } from 'src/api/authentication';

export const Route = createFileRoute('/authentication/logout')({
	loader: async () => {
		await logout();
		// trigger hard refresh to clear provider session
		window.location.href = '/authentication/login';
	},
});
